import { useEffect, useMemo, useState } from "react";
import Countdown from "./Countdown";

export interface Voucher {
    id: string;
    title: string;
    desc: string;
    disabled?: boolean;
}

interface Props {
    open: boolean;
    onClose: () => void;
    vouchers: Voucher[];
    defaultSelected?: string[];
    onSubmit: (ids: string[]) => void;
}

export default function PromoVoucherModal({
    open,
    onClose,
    vouchers,
    defaultSelected = [],
    onSubmit
}: Props) {

    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState<string[]>(defaultSelected);

    // lock scroll body when modal open
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [open]);

    // search filter
    const filtered = useMemo(() => {
        return vouchers.filter(v =>
            v.title.toLowerCase().includes(search.toLowerCase()) ||
            v.desc.toLowerCase().includes(search.toLowerCase())
        );
    }, [search, vouchers]);

    // toggle item
    const toggle = (id: string, disabled?: boolean) => {
        if (disabled) return;

        setSelected(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        );
    };

    // submit
    const handleSubmit = () => {
        onSubmit(selected);
        onClose();
    };

    if (!open) return null;

    return (
        <div
            role="presentation"
            id="modalPromoList"
            className="MuiModal-root styles_modalContainer__Sdvdc css-8ndowl"
        >

            {/* backdrop */}
            <div
                className="MuiBackdrop-root"
                style={{ opacity: 1 }}
                onClick={onClose}
            />

            {/* modal main */}
            <div className="MuiGrid-root styles_confirm_modal_wrap__q6yk7">

                {/* HEADER */}
                <div className="MuiGrid-root styles_modal_title__Tpult MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between">
                    <p className="MuiTypography-root styles_modalVoucherList_title__m5Bv3 MuiTypography-body1">
                        Danh sách mã giảm giá
                    </p>

                    <svg
                        className="MuiSvgIcon-root styles_close__JfKfm"
                        viewBox="0 0 24 24"
                        onClick={onClose}
                    >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                </div>

                <div className="MuiBox-root css-n6fgso">
                    {/* NOTE */}
                    <div className="styles_notifySelectVoucher__DIGpC">
                        Bạn có thể chọn nhiều hơn 1 mã giảm giá
                    </div>

                    {/* SEARCH */}
                    <div className="MuiBox-root css-8atqhb">
                        <div className="MuiFormControl-root MuiTextField-root styles_inputSearchVoucher__8IG7n">
                            <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedStart MuiOutlinedInput-adornedStart MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                <div className="MuiInputAdornment-root MuiInputAdornment-positionStart">
                                    <span style={{ boxSizing: 'border-box', display: 'inline-block', overflow: 'hidden', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', position: 'relative', maxWidth: '100%' }}>
                                        <span style={{ boxSizing: 'border-box', display: 'block', width: '17px', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', maxWidth: '100%' }}>
                                            <img alt="" aria-hidden="true" src="https://thuocsi.vn/images/promoCode/coupon_icon.svg" style={{ display: 'block', maxWidth: '100%', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px' }} />
                                        </span>
                                        <img alt="icon phone" src="https://thuocsi.vn/images/promoCode/coupon_icon.svg" decoding="async" data-nimg="intrinsic" style={{ position: 'absolute', inset: '0px', boxSizing: 'border-box', padding: '0px', border: 'none', margin: 'auto', display: 'block', width: '0px', height: '0px', minWidth: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%' }} />
                                    </span>
                                </div>
                                <input aria-invalid="false" placeholder="Nhập mã cần tìm" type="text" className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedStart MuiOutlinedInput-inputAdornedStart MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd" value={search}
                                    onChange={e => setSearch(e.target.value)} />
                                <div className="MuiInputAdornment-root MuiInputAdornment-positionEnd">
                                    <button className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnSearchVoucher__CTqb3" type="button">
                                        <span className="MuiButton-label">Tìm kiếm</span>
                                        <span className="MuiTouchRipple-root"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* LIST */}
                <div className="styles_coupon_list_wrapper__bgnqH">
                    <div className="styles_sectionVoucher_sticky__GZNXe">
                        <p className="MuiTypography-root styles_sectionVoucher_title__vXIVr MuiTypography-body1">Mã giảm giá từ nhà bán hàng</p>
                    </div>
                    {filtered.map(v => (
                        <div className="styles_voucherList_container__mD4a1">
                            <div key={v.id} className="MuiGrid-root" style={{ position: "relative", overflow: "hidden" }}>

                                <div className="styles_voucherLeftMissingPart__Dd9yV" style={{ backgroundColor: "#fff" }}></div>

                                <div className="MuiGrid-root styles_voucherItem_wrapper_cart__ejF4e">

                                    <div className="MuiGrid-root styles_voucherContainer_upper__P4pdw MuiGrid-container">

                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10 MuiGrid-grid-md-10" style={{ paddingRight: 8 }}>
                                            <p className="MuiTypography-root styles_voucherContent_title__W0Q3Z MuiTypography-body2 MuiTypography-noWrap">
                                                {v.title}
                                            </p>

                                            <p className="MuiTypography-root MuiTypography-body2" style={{ fontSize: 14 }}>
                                                <div className="styles_voucherContent_desc__ANOqH styles_content_2Line__BrNP1">
                                                    {v.desc}
                                                </div>
                                            </p>
                                        </div>

                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 MuiGrid-grid-md-2" style={{ position: "relative", marginTop: 15 }}>
                                            <img src="https://cdn-web-next.thuocsi.vn/images/promoCode/logo_med_x.svg" alt="logo internal seller" style={{ width: 68, height: 68 }} />
                                        </div>
                                    </div>

                                    <div className="styles_voucherDivider__7rclz" />

                                    <div className="MuiGrid-root styles_voucherContainer_downer__DSU6c">

                                        <div className="MuiGrid-root MuiGrid-container">

                                            <div className="MuiGrid-root styles_expiredDateBarWrapper__ffAl6 MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-md-4 h-[32px] flex items-center">
                                                <p className="MuiTypography-root MuiTypography-body2" style={{ lineHeight: "14px", color: "#000", fontSize: 12 }}>
                                                    <span style={{ color: "rgb(212, 50, 59)" }}>
                                                        Còn <div style={{ display: "inline-block" }}><Countdown initial="07:51:58" /></div>
                                                    </span>
                                                </p>
                                            </div>

                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-8 MuiGrid-grid-md-8">

                                                <div className="MuiGrid-root" style={{ display: "flex", justifyContent: "space-between", padding: "0 20px 0 12px" }}>
                                                    <div />
                                                    <button className="MuiButtonBase-root MuiButton-root MuiButton-text styles_cartVoucherBtn__IanzC" tabIndex={0} type="button" onClick={() => toggle(v.id, v.disabled)}>
                                                        <span className="MuiButton-label">
                                                            <span className="MuiButtonBase-root MuiIconButton-root jss231 MuiCheckbox-root MuiCheckbox-colorSecondary jss232 Mui-checked MuiIconButton-colorSecondary" aria-disabled="false" style={{ padding: '0px' }}>
                                                                <span className="MuiIconButton-label">
                                                                    <input className="jss234" type="checkbox" data-indeterminate="false" aria-label="controlled" value="" checked />
                                                                    <span style={{ boxSizing: 'border-box', display: 'inline-block', overflow: 'hidden', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', position: 'relative', maxWidth: '100%' }}>
                                                                        {selected.includes(v.id) ? (
                                                                            <img
                                                                                alt="checked"
                                                                                src="https://cdn-web-next.thuocsi.vn/images/cart/checked_icon.svg"
                                                                                style={{ width: 28, height: 28 }}
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                alt="unchecked"
                                                                                src="https://cdn-web-next.thuocsi.vn/images/cart/checkbox_icon.svg"
                                                                                style={{ width: 28, height: 28 }}
                                                                            />
                                                                        )}
                                                                    </span>
                                                                </span>
                                                                <span className="MuiTouchRipple-root"></span>
                                                            </span>
                                                        </span>
                                                        <span className="MuiTouchRipple-root"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="styles_voucherRightMissingPart__ghZZb" style={{ backgroundColor: "#fff" }}></div>
                            </div>
                        </div>
                    ))}

                    {filtered.length === 0 && (
                        <div style={{ padding: 16, color: "#888" }}>
                            Không tìm thấy mã phù hợp
                        </div>
                    )}
                </div>

                {/* FOOTER */}
                <div className="styles_modal_footer__MPe6I MuiBox-root css-0">
                    <p className="MuiTypography-root MuiTypography-body2">{selected.length} Mã giảm giá đã được chọn</p>
                    <button className="MuiButtonBase-root MuiButton-root MuiButton-text styles_modalButtonClose__eQOiz" onClick={handleSubmit} type="button">
                        <span className="MuiButton-label">Đồng ý</span><span className="MuiTouchRipple-root"></span>
                    </button>
                </div>
            </div>
        </div>
    );
}
